module.exports = __webpack_public_path__ + "static/media/image-placeholder.ac61ce8d.png";